import React from "react";
import { useLanguage } from "./LanguageContext";
import { Button } from "@/shared/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/shared/components/ui/dropdown-menu";
import { Globe } from "lucide-react";

export default function LanguageSwitcher({ variant = "default", className }) {
  const { language, setLanguage } = useLanguage();

  const languages = [
    { code: "en", name: "English", flag: "🇺🇸" },
    { code: "th", name: "ไทย", flag: "🇹🇭" },
  ];

  const oppositeLang = languages.find(l => l.code !== language) || languages[1];

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          className={`
            rounded-lg
            bg-[#0f172a]
            border border-cyan-500/20
            text-gray-300
            hover:bg-cyan-500/10
            hover:text-cyan-400
            hover:shadow-[0_0_10px_rgba(0,255,255,0.4)]
            transition-all duration-200
            ${className || ""}
          `}
        >
          <span className="font-semibold text-sm tracking-wide">
            {oppositeLang.code.toUpperCase()}
          </span>
        </Button>
      </DropdownMenuTrigger>

      <DropdownMenuContent
        align="end"
        className="
          bg-gradient-to-br from-[#0f172a] via-[#0b1220] to-[#0f172a]
          border border-cyan-500/20
          text-gray-200
          shadow-[0_0_25px_rgba(0,255,255,0.15)]
          backdrop-blur-xl
        "
      >
        {languages.map((lang) => (
          <DropdownMenuItem
            key={lang.code}
            onClick={() => setLanguage(lang.code)}
            className={`
              flex items-center rounded-md
              text-gray-300
              hover:bg-cyan-500/10
              hover:text-cyan-400
              focus:bg-cyan-500/10
              focus:text-cyan-400
              transition-all duration-200
              ${language === lang.code ? "bg-cyan-500/15 text-cyan-400" : ""}
            `}
          >
            <span className="mr-2 text-base">{lang.flag}</span>
            <span>{lang.name}</span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
